import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOperationTimeCheck } from '../hooks/useOperationTime';
import { useCart } from '../contexts/CartContext';
import ServiceClosedModal from './ServiceClosedModal';

interface OperationTimeGuardProps {
  children: React.ReactNode;
  protectedPaths: string[];
}

const OperationTimeGuard: React.FC<OperationTimeGuardProps> = ({ 
  children, 
  protectedPaths 
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAndExecute } = useOperationTimeCheck();
  const { clearCart } = useCart();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Figma html-to-design: 캡처 중에는 운영시간 리다이렉트로 해시 쿼리가 지워지지 않게 함
    if (location.search.includes("figmacapture")) {
      return;
    }

    const currentPath = location.pathname;
    const isProtectedPath = protectedPaths.some(path => 
      currentPath.startsWith(path)
    );

    if (isProtectedPath) {
      checkAndExecute(
        () => {
          console.log('[OperationTimeGuard] Operation time check passed, allowing access');
          // 운영시간이면 그대로 진행
        },
        () => {
          console.log('[OperationTimeGuard] Operation time check failed, redirecting to home');
          // 운영시간이 아니면 장바구니 비우고 모달 표시 후 홈으로 리다이렉트
          clearCart();
          setShowModal(true);
          navigate('/', { replace: true });
        },
        true // clearCartOnClosed = true
      );
    }
  }, [location.pathname, protectedPaths, checkAndExecute, clearCart, navigate]);

  return (
    <>
      {children}
      <ServiceClosedModal 
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default OperationTimeGuard; 